import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import { ProposalProduct } from "generated/graphql";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import { draftColors } from "./draftDesignTokens";
import { getProductDisplayName } from "./stageOrderingState";

type ArrangeProductItemProps = {
  product: ProposalProduct;
  dragHandleProps: DraggableProvidedDragHandleProps | null | undefined;
};

export default function ArrangeProductItem({ product, dragHandleProps }: ArrangeProductItemProps) {
  return (
    <MDBox display="flex" alignItems="center" gap="8px" px="12px" py="8px">
      <MDBox
        {...dragHandleProps}
        sx={{ cursor: "grab", display: "flex", color: draftColors.textSecondary }}
      >
        <Icon fontSize="small">drag_indicator</Icon>
      </MDBox>
      <UiTypography uiVariant="body-sm" sx={{ flex: 1 }}>
        {getProductDisplayName(product)}
      </UiTypography>
    </MDBox>
  );
}
